// Pricing config — India vs International
export interface PricingConfig {
  currency: 'INR' | 'USD';
  symbol: string;
  monthly: number;
  yearly: number;
  monthlyDisplay: string;
  yearlyDisplay: string;
  yearlyPerMonth: string;
  yearlySaving: string;
  gateway: 'razorpay' | 'dodo';
}

export const PRICING: Record<'IN' | 'INTL', PricingConfig> = {
  IN: {
    currency: 'INR',
    symbol: '₹',
    monthly: 199,
    yearly: 999,
    monthlyDisplay: '₹199',
    yearlyDisplay: '₹999',
    yearlyPerMonth: '₹83/mo',
    yearlySaving: 'Save 58%',
    gateway: 'razorpay',
  },
  INTL: {
    currency: 'USD',
    symbol: '$',
    monthly: 4.99,
    yearly: 49.99,
    monthlyDisplay: '$4.99',
    yearlyDisplay: '$49.99',
    yearlyPerMonth: '$4.16/mo',
    yearlySaving: 'Save 17%',
    gateway: 'dodo',
  },
};

// Detect country using free IP API — no key needed
let cachedCountry: 'IN' | 'INTL' | null = null;

export const getCountryPricing = async (): Promise<PricingConfig> => {
  if (cachedCountry) return PRICING[cachedCountry];

  try {
    const res = await fetch('https://ipapi.co/country/', { signal: AbortSignal.timeout(3000) });
    const country = await res.text();
    cachedCountry = country.trim() === 'IN' ? 'IN' : 'INTL';
  } catch {
    // Default to India if detection fails
    cachedCountry = 'IN';
  }

  return PRICING[cachedCountry];
};

export const getCachedPricing = (): PricingConfig => {
  return PRICING[cachedCountry || 'IN'];
};